const districtAdmins = {
  all_district_admins: '🏛️ Todos los administradores de distrito',
  create: 'Crear Nuevo Administrador de Distrito',
  firstname: 'Nombre',
  lastname: 'Apellido Paterno',
  lastname2nd: 'Apellido Materno',
  email: 'Correo Electrónico',
  dni: 'DNI',
  birth_date: 'Fecha de Nacimiento',
  school_group: 'Grupo Escolar (Distrito)',
  search_school_group: 'Buscar grupo escolar...',
  general_information: 'Información General',
  select_school_group: 'Seleccionar Grupo Escolar',
  search_by_name: 'Buscar por nombre',
};

export default districtAdmins;
